import { gql } from "@apollo/client";

export const AUTHENTICATE_WITH_GITHUB_MUTATION = gql`
  mutation AuthenticateWithGithub($code: String!) {
    authenticateWithGithub(code: $code) {
      token
    }
  }
`;

export const CREATE_UNVERIFIED_USER_MUTATION = gql`
  mutation CreateUser($email: String!, $githubId: String!) {
    createUser(email: $email, githubId: $githubId) {
      email
      githubId
      id
      verified
    }
  }
`;
